import { Sort } from "./Sort"

export interface FilterProps {
  page: number
  size: number
  prevSize?: number
  sort: Sort[]
  empty?: boolean
  defaultSize?: number
}

export class Filter {
  page: number
  size: number
  prevSize?: number
  sort: Sort[]
  empty?: boolean
  defaultSize: number
  unpaged?: boolean

  constructor(props: FilterProps) {
    this.defaultSize = 20
    this.size = props?.size ?? this.defaultSize
    this.prevSize = props?.prevSize
    this.page = props?.page ?? 1
    this.sort = props?.sort ?? []
    this.empty = props?.empty
  }

  addSort(field: string, isAsc: boolean) {
    this.sort = [new Sort(field, isAsc)]
  }

  addMultipleSort(sorts: { field: string; isAsc: boolean }[]) {
    this.sort = sorts.map(s => new Sort(s.field, s.isAsc))
  }

  removeSort() {
    this.sort = []
  }

  static createDefault(): Filter {
    return new Filter({
      size: 20,
      page: 1,
      sort: []
    })
  }

  static create(props: FilterProps): Filter {
    return new Filter(props)
  }

  getJsonObj(
    {
      params,
      withoutPagination,
      isTextFormatting
    }: { params?: any; withoutPagination?: boolean; isTextFormatting?: boolean } = {
      params: {},
      withoutPagination: false,
      isTextFormatting: true
    }
  ) {
    let data = { ...params }
    if (!withoutPagination && !this.unpaged) {
      data = {
        ...data,
        size: this.size,
        prevSize: this.page > 1 ? this.prevSize : undefined,
        page: this.page - 1,
        sort: this.sort.map(sort => sort.getString())
      }
    } else {
      delete data.size
      delete data.page
      data.unpaged = this.unpaged
    }

    const result: URLSearchParams = new URLSearchParams()
    if (isTextFormatting) {
      const searchKeys = ["q", "text"]
      for (const key of searchKeys) {
        if (data[key] && typeof data[key] === "string") {
          const text = data[key].replace(/[^a-zA-Z0-9]+/g, " ").trim()
          data[key] = text ? text : " "
        }
      }
    }

    for (const item in data) {
      if (this.empty || data[item] !== "") {
        if (typeof data[item] !== "object") {
          if (item === "sort") {
            for (let i = 0; i < data[item].length; i++) {
              result.append(item, data[item][i])
            }
          } else if (data[item] !== undefined) {
            result.append(item, data[item])
          }
        } else {
          if (data[item] && Object.keys(data[item]).length) {
            for (let i = 0; i < data[item].length; i++) {
              result.append(item, data[item][i])
            }
          }
        }
      }
    }
    return result
  }
}
